export const projectsNames = {
    store: 'store',
    admin: 'admin',
    funnels: 'funnels',
    partners: 'partners',
    templates: 'templates',
    modules: 'modules',
};

export const projectsAreas = {
    store: '',
    templates: '',
    modules: '',
    storeMobile: 'Areas/Mobile/',
    admin: '../Areas/Admin/',
    adminV3: '../Areas/Admin/Templates/AdminV3/',
    adminMobile: '../Areas/Admin/Templates/Mobile/',
    funnels: 'Areas/Landing/',
    partners: '../Areas/Partners/',
};
